var toUnsigned = function(value) {
  return value >>> 0;
};

module.exports = {
  toUnsigned: toUnsigned
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/mux.js/lib/utils/bin.js
// module id = 348
// module chunks = 0